import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'
import { State } from './types'
export interface CascadeAppliesData {
  /** 申请ID */
  id: string
  /** 下级团队ID */
  child_team_id: string
  /** 上级团队ID */
  parent_team_id: string
  /** 团队名称 */
  parent_team_name: string
  /** 接入码 */
  access_code: string
  /** 服务器地址 */
  server_host: string
  /** 服务器端口 */
  server_port: number
  /** 申请状态 1=待审核， 2=审核通过， 3=审核拒绝 */
  status: Extract<keyof typeof State, string>
  /** 申请时间 */
  apply_time: string
  /** 审批时间 */
  approve_time: string
  /** 审批原因 */
  approve_reason: string
  /** 创建时间 */
  create_time: string
  /** 更新时间 */
  update_time: string
  cascade_relation_id: string
  mode: 1 | 2
  role_id?:string
  permissions?:string[]
}
export interface CascadeApproveParams {
  /** 申请id */
  apply_id: string
  /** 是否通过 */
  approved: boolean
  /** 审批原因 */
  reason?: string
}
export interface CascadeAppliesParams {
  /** 每页数量 */
  limit?: number
  /** 页码 */
  page?: number
  /** 申请状态筛选 1=待审核， 2=审核通过， 3=审核拒绝 */
  status?: string | number
  keyword?: string
  date?: []
  start_time?: string
  end_time?: string
}

@Injectable()
export class CascadeService {
  constructor(private http: Http) {
  }
  // 审批
  getCascadeApprove(data: CascadeApproveParams) {
    return this.http.post<void>('/cascade/approve', data)
  }
  // 审批列表
  @ParamsClean()
  getCascadeApplyList(data: CascadeAppliesParams) {
    data.status ||= '0'
    return this.http.post<CascadeAppliesData>('/cascade/applies', data)
  }
}
